export default __webpack_public_path__ + "static/revojs_where-to-2592aa4eb926fd205a3497a422c78399.png";